<template>
  <div class="SliderMenu">
    <div class="main-content">

      <!-- GCC Filter Heading -->
      <div class="row">
        <div class="col-md-12">
          <div class="page-header margin-top-0px padding-left-right-15px">
            <h5 class="font-size-15px">Dashboard v2.0.2</h5>
          </div>
        </div>
      </div>
      <!-- GCC Filter Heading -->

      <div class="row vertical-align height-40-px">
        <div class="col-md-1 col-lg-1"></div>
        <div class="col-xs-10 col-sm-10 col-md-8 col-lg-8 padding-left-0px padding-right-0px text-align-left">

          <!-- Select / Deselect All -->
          <div class="text-left">
            <div class="btn-group course-selection-controls" role="group" aria-label="Selection Controls" v-if="groupCourses.length > 0 && gccSearchQuery.length === 0">
              <button type="button" class="btn btn-default btn-sm" id="deselect-all-courses"
                @click.stop="deselectAllCourses"
                :disabled="!getClearAllBtnState">
                  Clear All
              </button>

              <button type="button" class="btn btn-default btn-sm" id="select-all-courses"
                @click.stop="selectAllCourses"
                :disabled="getSelectAllBtnState">
                  Select All
              </button>
            </div>
          </div>
          <!-- Select / Deselect All -->

        </div>

        <!-- Open / Close Slider -->
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 padding-right-0px text-align-right padding-right-0px">
          <span class="glyphicon glyphicon-option-vertical cursor-pointer padding-right-0px" @click="closeSlider($event)"></span>
        </div>
        <!-- Open / Close Slider -->

        <div class="col-md-1 col-lg-1"></div>
      </div>

      <div class="row vertical-align" v-if="userIsAdmin">
        <div class="col-md-1 col-lg-1"></div>

        <div class="col-md-10 col-lg-10 padding-left-0px padding-right-0px margin-top-10px margin-bottom-10px">

          <!-- Group Selection Dropdown -->
          <select class="form-control input-sm group-selector" v-model="selectedGroup" @change="selectGroup">
              <option value=-1 disabled>Select Group</option>
              <option v-for="group in groups" :key="group.GroupId" :value="group">
                {{ `${group.GroupName} - ${group.CourseCount} Courses with ${group.ParticipantCount} Participants in ${group.CohortCount} cohorts` }}
              </option>
          </select>
          <!-- Group Selection Dropdown -->

          <!-- Group Course Search Field -->
          <input type="search" class="form-control input-sm" placeholder="Search Course..." v-model="gccSearchQuery">
          <!-- Group Course Search Field -->

        </div>
        <div class="col-md-1 col-lg-1"></div>
      </div>

      <div class="row vertical-align">
        <div class="col-md-1 col-lg-1"></div>

        <div class="col-md-10 col-lg-10 padding-left-0px padding-right-0px">

          <!-- Group Courses -->
          <div class="panel-group" id="gcc-course-list" v-if="groupCourses.length">

            <gcc-course v-for="course in availableGroupCourses"
              :key="course.GroupCourseMasterId"
              :courseObj="course">
            </gcc-course>

          </div>
          <!-- Group Courses -->

          <!-- If No Group Courses -->
          <div class="panel-group" v-else>
            <small class="red">No Courses available for selected Group</small>
          </div>
          <!-- If No Group Courses -->

        </div>
        <div class="col-md-1 col-lg-1"></div>
      </div>
      <!-- Added empty row to add space -->
      <div class="row">
      </div>
     <!-- Added empty row to add space -->

      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div>
  </div>
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import GCCFilterCourse from '@/components/dashboard_v2/GCCFilterCourse'
import isEmpty from 'lodash/isEmpty'
import findIndex from 'lodash/findIndex'
import forEach from 'lodash/forEach'
import filter from 'lodash/filter'
// import { constants } from '../../utils/constants'

export default {
  name: 'GccFilterMach2',

  components: {
    'alert-box': AlertBox,
    'gcc-course': GCCFilterCourse
  },

  data () {
    return {
      showAlertDialog: false,
      errorMsg: false,
      selectedGroup: this.$store.state.selectedGroup,
      selectedCohorts: [],
      selectedCourses: [],
      gccSearchQuery: '',
      availableGroupCourses: [],
      selectAllBtnState: false,
      clearAllBtnState: false,

      /* eslint-disable */
      selectAllCoursesButton: $('#select-all-courses'),
      deselectAllCoursesButton: $('#deselect-all-courses')
      /* eslint-enable */
    }
  },

  computed: {
    currSelectedGroupCourses: {
      get: function () {
        return this.$store.state.selectedGroupCourses
      }
    },

    groups () {
      return this.$store.getters.groups
    },

    defaultGroup () {
      return this.$store.getters.groups[0]
    },

    groupCourses () {
      return this.$store.getters.groupCourses
    },

    stats () {
      return this.$store.state.stats
    },

    userIsAdmin () {
      return this.$store.getters.userIsAdmin
    },

    userIsGroupAdmin () {
      return this.$store.getters.userIsGroupAdmin
    },

    groupName () {
      return this.selectedGroupGlobalVal.GroupName
    },

    getSelectAllBtnState: {
      get: function () {
        return this.selectAllBtnState
      }
    },

    getClearAllBtnState: {
      get: function () {
        return this.clearAllBtnState
      }
    },

    selectedGroupGlobalVal: {
      get: function () {
        return this.$store.getters.selectedGroup
      }
    },

    selectAllButton () {
      // eslint-disable-next-line
      return $('#select-all-courses')
    },

    deselectAllButton () {
      // eslint-disable-next-line
      return $('#deselect-all-courses')
    }
  },

  beforeDestroy () {
    this.eventHub.$off('course-selection-toggled')
    this.eventHub.$off('cohort-selection-toggled')
  },

  created () {
    this.eventHub.$on('course-selection-toggled', (courseID, isSelected) => {
      // console.log('course-selection-toggled 193:')
      this.toggleCourseSelection(courseID, isSelected)
    })

    this.eventHub.$on('cohort-selection-toggled', (courseID, cohortID, isSelected) => {
      // console.log('cohort-selection-toggled 198:')
      this.toggleCohortSelection(courseID, cohortID, isSelected)
    })

    this.availableGroupCourses = this.$store.getters.groupCourses
  },

  mounted () {
    /* eslint-disable */
    this.$nextTick(() => {
      this.selectAllCoursesButton = this.selectAllButton
      this.deselectAllCoursesButton = this.deselectAllButton
    })
    /* eslint-enable */
  },

  methods: {
    selectedGCCount: function (isSelected) {
      return filter(this.currSelectedGroupCourses, course => {
        return course.isSelected === isSelected
      }).length
    },

    updateClearAllBtnState: function () {
      this.clearAllBtnState = this.selectedGCCount(true) > 0
    },

    updateSelectAllBtnState: function () {
      // AK: Check and update the flag only if we have previously selected group courses with us.
      if (this.currSelectedGroupCourses.length > 0) {
        this.selectAllBtnState = this.groupCourses.length === this.selectedGCCount(true)
      } else {
        this.selectAllBtnState = false
      }
    },
    toggleCourseSelection (courseID, isSelected) {
      let course = this.$store.getters.courseById(courseID)
      let courseCohorts = this.$store.getters.cohortsByCourseId(courseID)

      /* eslint-disable */
     
      const wasPresent = findIndex(this.selectedCourses, (obj) => {
        return obj.GroupCourseMasterId === courseID
      })
      // console.log('wasPresent:' + wasPresent)
      if (wasPresent === -1) {
        this.selectedCourses.push(course)
        this.selectedCohorts.push(courseCohorts)
        this.selectedCohorts = _.flatten(this.selectedCohorts)
      }

      // AK: Get current Course index from Array.
      const foundCourseIndex = findIndex(this.selectedCourses, (obj) => {
        // console.log(obj.GroupCourseMasterId + ' ===  ' + courseID)
        // console.log('246 IsSelected: ' + isSelected)
        return obj.GroupCourseMasterId === courseID
      })
      // AK: If found then update it as false
      if (foundCourseIndex > -1) {
        this.selectedCourses[foundCourseIndex].isSelected = isSelected
      }
      // AK: Mark all cohorts associated with current Course with current isSelected Flag.
      forEach(this.selectedCohorts, (obj) => {
        if (obj.GroupCourseMasterId === courseID) {
          // console.log(obj.GroupCourseMasterId + ' ===  ' + courseID)
          // console.log('255 IsSelected: ' + isSelected)
          obj.isSelected = isSelected
        }
      })
      if (this.selectedCourses.length === 0) {
        this.selectAllCoursesButton.prop('disabled', false)
        this.deselectAllCoursesButton.prop('disabled', true)
      }

      /* eslint-enable */

      this.$store.commit('setSelectedCourses', this.selectedCourses)
      this.$store.commit('setSelectedCohorts', this.selectedCohorts)
      this.eventHub.$emit('gccFilterUpdated')
    },

    toggleCohortSelection (courseID, cohortID, isSelected) {
      /* eslint-disable */
      let course = this.$store.getters.courseById(courseID)
      let cohort = _.find(this.$store.state.groupCoursesCohorts, gcCohort => { return gcCohort.CohortId === cohortID })
      let selectedCourseCohorts = []
      
      const wasPresent = findIndex(this.selectedCohorts, (obj) => {
        return obj.CohortId === cohortID
      })
      if (wasPresent === -1) {
        this.selectedCohorts.push(cohort)
      }
      
      // AK: Get current Cohort index from Array.
      const foundCohortIndex = findIndex(this.selectedCohorts, (obj) => {
        return obj.CohortId === cohortID
      })
      // AK: If found then update it as false
      if (foundCohortIndex > -1) {
        this.selectedCohorts[foundCohortIndex].isSelected = isSelected
      }
      // AK: Calculate number of count of currently performed state
      const foundEntries = filter(this.selectedCohorts, (obj) => {
        return obj.isSelected === isSelected && obj.GroupCourseMasterId === courseID
      })
      const totalEntries = filter(this.$store.getters.cohortsByCourseId(courseID), (obj) => {
        return obj.GroupCourseMasterId === courseID
      })
      // AK: Perform course selection/unselection automatically for Course
      if (totalEntries.length > 0) {
        let foundCourseIndex = findIndex(this.selectedCourses, (obj) => {
          return obj.GroupCourseMasterId === courseID
        })
        /* AK: If found already with us then check wheather total cohort count === total selected cohort count?
          If yes then apply same currently performed user action for Group course (i.e. select/unselect action)
          If no then keep the current Group course as selected only (Since we have to show no. of selected course on right side)
        */
        if (foundCourseIndex > -1) {
          this.selectedCourses[foundCourseIndex].isSelected = parseInt(foundEntries.length) === parseInt(totalEntries.length) ? isSelected : true
        } else {
          this.selectedCourses.push(course)
          foundCourseIndex = findIndex(this.selectedCourses, (obj) => {
            return obj.GroupCourseMasterId === courseID
          })
          this.selectedCourses[foundCourseIndex].isSelected = parseInt(foundEntries.length) === parseInt(totalEntries.length) ? isSelected : true
        }
      }
      
      selectedCourseCohorts = _.filter(this.selectedCohorts, cohort => {
        return cohort.GroupCourseMasterId === courseID
      })

      /* eslint-enable */
      this.$store.commit('setSelectedCourses', this.selectedCourses)
      this.$store.commit('setSelectedCohorts', this.selectedCohorts)
      this.eventHub.$emit('gccFilterUpdated')
    },

    closeSlider: function (event) {
      this.$emit('closeSlider', true)
    },

    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },

    deselectAllCourses ($event) {
      /* eslint-disable */
      this.selectAllCoursesButton.prop('disabled', false)
      this.deselectAllCoursesButton.prop('disabled', true)

      this.selectedCourses = []
      this.selectedCohorts = []
      this.$store.commit('setSelectedCourses', this.selectedCourses)
      this.$store.commit('setSelectedCohorts', this.selectedCohorts)
      this.$store.commit('deselectAllCourses')
      this.eventHub.$emit('deselectAllCourses')
      this.eventHub.$emit('gccFilterUpdated')
      /* eslint-enable */
    },

    selectAllCourses ($event) {
      /* eslint-disable */
      this.deselectAllCoursesButton.prop('disabled', false)
      this.selectAllCoursesButton.prop('disabled', true)

      this.selectedCourses = this.$store.getters.groupCourses
      this.selectedCohorts = this.$store.getters.groupCohorts
      this.$store.commit('setSelectedCourses', this.selectedCourses)
      this.$store.commit('setSelectedCohorts', this.selectedCohorts)
      this.$store.commit('selectAllCourses')
      this.eventHub.$emit('selectAllCourses')
      this.eventHub.$emit('gccFilterUpdated')
      /* eslint-enable */
    },

    selectGroup () {
      this.reset()
      this.$store.commit('resetGccData')
      this.$store.commit('setSelectedGroup', this.selectedGroup)
      this.$store.dispatch('fetchAndSetAllGroupData')
      this.eventHub.$emit('groupSelected')
      this.$nextTick(() => {
        this.selectAllCourses()
      })
    },

    /**
     * Reset GCC Filter data
     */
    reset () {
      this.$set(this, 'selectedCourses', [])
      this.$set(this, 'selectedCohorts', [])
      this.$store.commit('groupCoursesSelected', this.selectedCourses)
      this.$store.commit('setSelectedCohorts', this.selectedCohorts)
    },

    findBy: function (list, value, column) {
      return list.filter(function (item) {
        return String(item[column]).toLowerCase().indexOf(String(value).toLowerCase()) !== -1
      })
    }
  },

  watch: {
    gccSearchQuery: function (newValue, oldValue) {
      // AK: As soon as user type anythings in search, start searching it
      this.availableGroupCourses = this.findBy(this.groupCourses, this.gccSearchQuery, 'CourseTitle')
      this.eventHub.$emit('gccFilterUpdated')
    },

    selectedGroupGlobalVal: function (newValue, oldValue) {
      if (!isEmpty(newValue)) {
        this.selectedGroup = newValue
      }
    },

    groupCourses: function (newVal, oldVal) {
      this.availableGroupCourses = newVal
    },

    currSelectedGroupCourses: function (newVal, oldVal) {
      // AK: Update the select and clear all button states on each Group course update
      this.updateClearAllBtnState()
      this.updateSelectAllBtnState()
    },

    stats: function (newVal, oldVal) {
      // AK: On each group change, load all the group courses and cohorts into the list.
      this.selectedCourses = this.$store.getters.groupCourses
      this.selectedCohorts = this.$store.getters.groupCohorts
      this.$store.commit('setSelectedCourses', this.selectedCourses)
      this.$store.commit('setSelectedCohorts', this.selectedCohorts)
    }
  }
}
</script>

<style lang="scss" scoped>
.SliderMenu {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.margin-right-1point5Perc{
  margin-right:1.5% !important;
}
.width-97Point4{
  width:97.4% !important;
}
.sendGridList{
  min-height: 57vh;
}
/* Using Only for footer */
.footer{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
.cursor-pointer {
  cursor: pointer;
}
.sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 70px;
    left: 0;
    background-color: #34495e;
    overflow-x: hidden;
    transition: 0.5s;
    padding-top: 60px;
}

.sidenav a {
    padding: 0px 0px 0px .5em;
    text-decoration: none;
    font-size: 14px;
    color: #27345b!important;
    display: block;
    transition: 0.3s;
}

.sidenav a:hover {
    color: #f1f1f1;
}

.sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
}

@media screen and (max-height: 450px) {
  .sidenav {padding-top: 15px;}
  .sidenav a {font-size: 18px;}
}
.text-align-left {
  text-align: left !important;
}
.text-align-right {
  text-align: right !important;
}
.float-left {
  float: left !important;
}
.glyphicon {
  font-size: 20px;
}
.dark-grey-bg {
  background-color: #969696;
}
.white-text-color {
  color: #ffffff !important;
}
.left-grey-border {
  border-left: 1px solid #dcdcdc;
}
.font-size-10px {
  font-size: 10px !important;
}
.padding-left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-top-10px {
  margin-top: 10px !important;
}
.margin-bottom-10px {
  margin-bottom: 10px !important;
}

.margin-top-0px{
  margin-top:0px;
}
.font-size-15px{
  font-size:15px;
}
.padding-left-right-15px{
  padding-left: 15px;
  padding-right: 15px;
}
.group-selector {
  margin: 0 auto 1em auto;
}
.height-40-px {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard_v2/GCCFilterMach2.vue